import AnimatedArrow from "../AnimatedArrow";
import ParallaxSections from "../ParllaxSections";

export default function Home() {
  return (
    <div>
      <div className="animate-fade-right animate-once animate-duration-[2500ms] animate-delay-300 text-center text-2xl font-bold text-blue-500 font-ocr_font text-3xl">
        Get the support you and your clients deserve

      </div>
      <AnimatedArrow />
      <ParallaxSections></ParallaxSections>
    </div>

  );
}
